import ProofDeclarationCard from "./proofDeclarationCard";
export default ProofDeclarationCard;